export const t = (s: string) => s
